module.exports = __webpack_public_path__ + "static/img/11.3bc9848.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/en/btn2/11.jpg
// module id = oOVc
// module chunks = 0